import { TranslateService } from '@ngx-translate/core';

export function getTranslatedLinkBlocks(keys: string[], linksCount: number, translator: TranslateService): { title: string, links: { title: string, href: string } }[] {
  const columns = [];
  keys.forEach((key) => {
    const title = translator.instant(`footerLinks.${key}.title`);
    const links = [];

    for (let i = 1; i <= linksCount; i++) {
      const linkTitle = translator.instant(`footerLinks.${key}.links.link_${i}.title`);
      const href = translator.instant(`footerLinks.${key}.links.link_${i}.href`);

      if (linkTitle && href) {
        const order = translator.instant(`footerLinks.${key}.links.link_${i}.order`);
        links.push({
          title: translator.instant(`footerLinks.${key}.links.link_${i}.title`),
          href: translator.instant(`footerLinks.${key}.links.link_${i}.href`)
        });
      }
    }

    if (title && links.length) {
      columns.push({ title, links });
    }
  });

  return columns;
}

export function getTranslatedLinks(key: string, linksCount: number, translator: TranslateService): { title: string, href: string }[] {
  const links = [];

  for (let i = 1; i <= linksCount; i++) {
    const linkTitle = translator.instant(`footerLinks.${key}.links.link_${i}.title`);
    const href = translator.instant(`footerLinks.${key}.links.link_${i}.href`);

    if (linkTitle && href) {
      links.push({
        title: translator.instant(`footerLinks.${key}.links.link_${i}.title`),
        href: translator.instant(`footerLinks.${key}.links.link_${i}.href`),
      });
    }
  }

  return links;
}
